/**
 * @generated SignedSource<<9002fcd8354e4abf978907a7cfcf3a7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreatePerspectiveInputObject = {
  name: string;
};
export type perspectiveSwitcher_CreatePerspectiveMutation$variables = {
  input: CreatePerspectiveInputObject;
};
export type perspectiveSwitcher_CreatePerspectiveMutation$data = {
  readonly createPerspective: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly perspective: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type perspectiveSwitcher_CreatePerspectiveMutation = {
  response: perspectiveSwitcher_CreatePerspectiveMutation$data;
  variables: perspectiveSwitcher_CreatePerspectiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Perspective",
  "kind": "LinkedField",
  "name": "perspective",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "perspectiveSwitcher_CreatePerspectiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePerspectiveMutationPayload",
        "kind": "LinkedField",
        "name": "createPerspective",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "perspectiveSwitcher_CreatePerspectiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePerspectiveMutationPayload",
        "kind": "LinkedField",
        "name": "createPerspective",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6369d0630b35ef8b4f826c1fdbcb44c1",
    "id": null,
    "metadata": {},
    "name": "perspectiveSwitcher_CreatePerspectiveMutation",
    "operationKind": "mutation",
    "text": "mutation perspectiveSwitcher_CreatePerspectiveMutation(\n  $input: CreatePerspectiveInputObject!\n) {\n  createPerspective(input: $input) {\n    perspective {\n      id\n      name\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "075a1b2a7780d095579b301c704795a0";

export default node;
